export const setHeaderGlassGradient = (surface, nav, w, h, menuHeight, frameWidth = w, offsetX = 0, midpointColor = '--color-black-70') => {
    const gradientHeight = h + menuHeight * 1.04;
    const angle = 156 * Math.PI / 180;
    const dx = Math.sin(angle);
    const dy = -Math.cos(angle);
    const length = Math.abs(w * dx) + Math.abs(h * dy);
    const x1 = offsetX + (w - dx * length) / 2;
    const y1 = (h - dy * length) / 2;
    const x2 = offsetX + (w + dx * length) / 2;
    const y2 = (h + dy * length) / 2;
    const colors = window.getComputedStyle(nav);
    const stops = [
        ['0%', '--color-white-40'],
        ['40%', '--color-white-20'],
        ['50%', midpointColor],
        ['100%', '--color-white-40'],
    ].map(([offset, color]) => '<stop offset="' + offset + '" stop-color="' + colors.getPropertyValue(color).trim() + '"/>').join('');
    const gradient = '<svg xmlns="http://www.w3.org/2000/svg" width="' + frameWidth + '" height="' + gradientHeight + '" viewBox="0 0 ' + frameWidth + ' ' + gradientHeight + '"><defs><linearGradient id="border" gradientUnits="userSpaceOnUse" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '">' + stops + '</linearGradient></defs><rect width="100%" height="100%" fill="url(#border)"/></svg>';
    surface.style.setProperty('--dropdown-border-gradient', 'url("data:image/svg+xml,' + encodeURIComponent(gradient) + '")');

};

export const roundedHeaderGlassPath = (points, maxRadius = 20) => {
    const vertices = points.filter((point, index) => {
        const prev = points[(index + points.length - 1) % points.length];
        const next = points[(index + 1) % points.length];
        return (point[0] - prev[0]) * (next[1] - point[1]) !== (point[1] - prev[1]) * (next[0] - point[0]);
    });
    return vertices.map((point, index) => {
        const prev = vertices[(index + vertices.length - 1) % vertices.length];
        const next = vertices[(index + 1) % vertices.length];
        const before = Math.hypot(prev[0] - point[0], prev[1] - point[1]);
        const after = Math.hypot(next[0] - point[0], next[1] - point[1]);
        const radius = Math.min(maxRadius, before / 2, after / 2);
        const along = (target, distance) => point.map((value, axis) => value + (target[axis] - value) * radius / distance);
        const turn = (point[0] - prev[0]) * (next[1] - point[1]) - (point[1] - prev[1]) * (next[0] - point[0]);
        return (index ? 'L' : 'M') + along(prev, before).join(' ') + 'A' + radius + ' ' + radius + ' 0 0 ' + (turn > 0 ? 1 : 0) + ' ' + along(next, after).join(' ');
    }).join(' ') + 'Z';
};
